
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CreateFreelancerNoteRequest,
  FreelancerNoteResource,
  SimpleError,
  UpdateFreelancerNoteRequest,
} from '../models';
import {
    CreateFreelancerNoteRequestFromJSON,
    CreateFreelancerNoteRequestToJSON,
    FreelancerNoteResourceFromJSON,
    FreelancerNoteResourceToJSON,
    SimpleErrorFromJSON,
    SimpleErrorToJSON,
    UpdateFreelancerNoteRequestFromJSON,
    UpdateFreelancerNoteRequestToJSON,
} from '../models';

export interface CreateFreelancerNoteOperationRequest {
    profileId: string;
    createFreelancerNoteRequest: CreateFreelancerNoteRequest;
}

export interface DeleteFreelancerNoteRequest {
    profileId: string;
    freelancerNoteId: string;
}

export interface GetFreelancerNotesRequest {
    profileId: string;
    limit?: number;
    offset?: Date;
}

export interface UpdateFreelancerNoteOperationRequest {
    profileId: string;
    freelancerNoteId: string;
    updateFreelancerNoteRequest: UpdateFreelancerNoteRequest;
}

/**
 * 
 */
export class FreelancerNotesApi extends runtime.BaseAPI {

    /**
     * Saves a new note on a freelancer 
          */
    async createFreelancerNoteRaw(requestParameters: CreateFreelancerNoteOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerNoteResource>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling createFreelancerNote().'
            );
        }

        if (requestParameters['createFreelancerNoteRequest'] == null) {
            throw new runtime.RequiredError(
                'createFreelancerNoteRequest',
                'Required parameter "createFreelancerNoteRequest" was null or undefined when calling createFreelancerNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerNoteResource>({
            path: `/profile/api/profiles/{profileId}/notes`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFreelancerNoteRequestToJSON(requestParameters['createFreelancerNoteRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerNoteResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Saves a new note on a freelancer 
          */
    async createFreelancerNote(requestParameters: CreateFreelancerNoteOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerNoteResource> {
        const response = await this.createFreelancerNoteRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Delete a freelancer note 
          */
    async deleteFreelancerNoteRaw(requestParameters: DeleteFreelancerNoteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling deleteFreelancerNote().'
            );
        }

        if (requestParameters['freelancerNoteId'] == null) {
            throw new runtime.RequiredError(
                'freelancerNoteId',
                'Required parameter "freelancerNoteId" was null or undefined when calling deleteFreelancerNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/profiles/{profileId}/notes/{freelancerNoteId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"freelancerNoteId"}}`, encodeURIComponent(String(requestParameters['freelancerNoteId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Delete a freelancer note 
          */
    async deleteFreelancerNote(requestParameters: DeleteFreelancerNoteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFreelancerNoteRaw(requestParameters, initOverrides);
    }

    /**
     * Returns notes linked to the given profileId  The notes are sorted in  reverse chronological order (newest first).   The resource is paginated using offset+limit parameters. 
          */
    async getFreelancerNotesRaw(requestParameters: GetFreelancerNotesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<FreelancerNoteResource>>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling getFreelancerNotes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = (requestParameters['offset'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<FreelancerNoteResource>>({
            path: `/profile/api/profiles/{profileId}/notes`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(FreelancerNoteResourceFromJSON);
        return response;
    }

    /**
     * Returns notes linked to the given profileId  The notes are sorted in  reverse chronological order (newest first).   The resource is paginated using offset+limit parameters. 
          */
    async getFreelancerNotes(requestParameters: GetFreelancerNotesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<FreelancerNoteResource>> {
        const response = await this.getFreelancerNotesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update a freelancer note 
          */
    async updateFreelancerNoteRaw(requestParameters: UpdateFreelancerNoteOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling updateFreelancerNote().'
            );
        }

        if (requestParameters['freelancerNoteId'] == null) {
            throw new runtime.RequiredError(
                'freelancerNoteId',
                'Required parameter "freelancerNoteId" was null or undefined when calling updateFreelancerNote().'
            );
        }

        if (requestParameters['updateFreelancerNoteRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFreelancerNoteRequest',
                'Required parameter "updateFreelancerNoteRequest" was null or undefined when calling updateFreelancerNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/api/profiles/{profileId}/notes/{freelancerNoteId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"freelancerNoteId"}}`, encodeURIComponent(String(requestParameters['freelancerNoteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFreelancerNoteRequestToJSON(requestParameters['updateFreelancerNoteRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update a freelancer note 
          */
    async updateFreelancerNote(requestParameters: UpdateFreelancerNoteOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateFreelancerNoteRaw(requestParameters, initOverrides);
    }

}
